<template>
  <div id="chatMessageList" @click="closeSettingMenu()">
    <div class="chatMessage" v-for="(message, index) in messageArray" :key="index" :class="message.style">
      <template v-if="message.cheerInfo && !message.cheerInfo.is_admin">
        <img :alt="message.imgAlt" :src="message.imgSrc"
          v-if="typeof message.imgSrc !== 'undefined' && message.imgSrc !== ''">
        <span class="messageUsername" v-if="message.username !== undefined" :rel="message.userid"
          @click="showMenu(this)">{{ message.username }}</span>
        <span class="messageText" v-if="message.username === undefined || isAdmin" v-html="message.msg"></span>
        <span class="messageText" v-else>{{ message.msg }}</span>
        <template>
          <div class="cheer_btn_wrap">
            <a href="javascript:" class="cheer_btn"
              v-if="message.cheerInfo.game_status && message.cheerInfo.game_status !== 'READY'"
              @click="goCheerSports(message.cheerInfo)">[{{ translateCheerTopic(message.cheerInfo.sports_name) }}] {{
                message.cheerInfo.home_name }} {{ message.cheerInfo.home_score }} - {{ message.cheerInfo.away_score }}
              {{ message.cheerInfo.away_name }} </a>
            <a href="javascript:" class="cheer_btn" v-else @click="goCheerSports(message.cheerInfo)">
              [{{ translateCheerTopic(message.cheerInfo.sports_name) }}] {{ message.cheerInfo.home_name }} VS
              {{ message.cheerInfo.away_name }} </a>
          </div>
        </template>
        <span class="enterRoomLink" @click="enterRoom(message.roomUid)" v-if="message.style.indexOf('link') > 0"></span>
        <span class="goShop" @click="goshop()" v-if="message.style.indexOf('shop') > -1"> -마켓으로 가기-</span>
        <span class="needPoint" @click="goMypage()" v-if="message.style.indexOf('needPoint') > -1"> -포인트 내역 가기-</span>
      </template>
      <template v-else-if="!message.cheerInfo">
        <div>
          <img :alt="message.imgAlt" :src="message.imgSrc"
            v-if="typeof message.imgSrc !== 'undefined' && message.imgSrc !== ''">
          <span class="messageUsername" v-if="message.username !== undefined" :rel="message.userid"
            @click="showMenu(this)">{{ message.username }}</span>
          <span class="messageText" v-if="message.username === undefined || isAdmin" v-html="message.msg"></span>
          <span class="messageText" v-else>{{ message.msg }}</span>
          <span class="enterRoomLink" @click="enterRoom(message.roomUid)"
            v-if="message.style.indexOf('link') > 0"></span>
          <span class="goShop" @click="goshop()" v-if="message.style.indexOf('shop') > -1"> -마켓으로 가기-</span>
          <span class="needPoint" @click="goMypage()" v-if="message.style.indexOf('needPoint') > -1"> -포인트 내역 가기-</span>
        </div>
        <div v-if="message.msg_point" class="messageTextEventBox">
          <span class="messageTextEvent">{{ message.msg_point }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { showContextMenu, enterChatRoom } from '../util'

export default {
  data() {
    return {
      isAdmin: window.is_admin
    }
  },
  computed: {
    messageArray() {
      return this.$store.getters.messages
    }
  },
  methods: {
    showMenu: showContextMenu,
    enterRoom: enterChatRoom,
    closeSettingMenu() {
      const showSettingMenu = document.querySelector('#chatSettingMenu').classList
      showSettingMenu.value ? showSettingMenu.remove('on')
        : null
    },
    goshop() {
      parent.location.href = '/main/sub/#/mypage/market'
    },
    goMypage() {
      parent.location.href = '/main/sub/#/mypage/point'
    },
    goCheerSports(info) {
      let mainHost = ""
      let parentHost = window.parentDomain || window.location.host
      const domains = [
        'nmd.co',
        'named.com',
        'xn--950bo4em5v.co',
        'named.net',
        'named2.net',
        'named2.kr'
      ]
      const rootDomain = domains.find(domain => parentHost.includes(domain)) || domains[0]

      switch (parentHost) {
        case `docker.${rootDomain}`:
          mainHost = `http://dev-sports.${rootDomain}`
          break
        case `m.docker.${rootDomain}`:
          mainHost = `http://m.docker.${rootDomain}`
          break
        case `${rootDomain}`:
          mainHost = `https://sports.${rootDomain}`
          break
        case `m.${rootDomain}`:
          mainHost = `https://m.${rootDomain}`
          break
        case `stage.${rootDomain}`:
          mainHost = `https://stage-sports.${rootDomain}`
          break
        case `m-stage.${rootDomain}`:
          mainHost = `https://m-stage.${rootDomain}`
          break
        case `dev.${rootDomain}`:
          mainHost = `http://dev-sports.${rootDomain}`
          break
        case `dev-m.${rootDomain}`:
          mainHost = `http://dev-m.${rootDomain}`
          break

        default:
          mainHost = "https://sports.nmd.co"
      }

      //If parentDomain is set, it means the page is opened in a mobile web, then don't open
      //a new window for sport but redirect to the sport game page.
      if (window.parentDomain) {
        const sportUrl = `/match/${info.sports_name}/${info.game_id}/cheer`
        if (window.onOpenSportMobile) {
          window.onOpenSportMobile(sportUrl, mainHost)
          return;
        }
      }

      const sportUrl = `${mainHost}/match/${info.sports_name}/${info.game_id}`
      window.open(sportUrl, '_blank', 'width=1000, height=901')
    },
    translateCheerTopic(topic) {
      const alias = {
        'soccer': '축구',
        'baseball': '야구',
        'basketball': '농구',
        'volleyball': '배구',
        'football': '미식축구',
        'hockey': '하키',
        'lol': 'LOL',
        'star': '스타크래프트'
      }
      return alias[topic]
    }
  },
  updated: function () {
    // manage message line
    let messages = this.$store.getters.messages
    if (window.is_admin) {
      if (messages.length > 2500) {
        this.$store.dispatch('sliceMessages', 500)
        this.$store.dispatch('addMessage', { 'msg': 'Admin 채팅 최적화를 수행하였습니다.', 'style': 'error' })
        setTimeout(function () {
          let screen = document.getElementById('chatMessageList')
          screen.scrollTop = screen.scrollHeight
        }, 500)
      }
    } else {
      if (messages.length > 1000) {
        this.$store.dispatch('sliceMessages', 500)
        this.$store.dispatch('addMessage', { 'msg': '채팅 최적화를 수행하였습니다.', 'style': 'error' })
      }
    }

    // set chat window fix down
    // let lastMessage = this.messageArray[this.messageArray.length - 1]
    let screen = document.getElementById('chatMessageList')
    if (screen) {
      let scrollbarPosition = screen.scrollTop
      let scrollLength = screen.scrollHeight - screen.offsetHeight
      // 스크롤이 맨 밑이 아니면 자동으로 스크롤이 내려가지 않음
      if (scrollLength <= scrollbarPosition + 150 ||
        !window.chattingLoadComplete) {
        screen.scrollTop = screen.scrollHeight
      }
      // console.log('updated: ', lastMessage, this.messageArray, scrollLength, scrollbarPosition, screen)
    }
  }
}
</script>

<style lang="scss">
#chatMessageList {
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: 100%;

  .chatMessage {
    position: relative;
    margin: 3px 9px 3px 20px;
    line-height: 130%;
    text-overflow: ellipsis;
    word-break: break-all;
    padding: 2px 0;

    .cheer_btn_wrap {
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;

      .cheer_btn {
        color: #467cff;
        white-space: nowrap;
        text-decoration: underline;
      }
    }

    &:empty {
      display: none;
    }

    .messageText {
      color: #666666;
    }

    .messageTextEventBox {
      text-align: center;
    }

    .messageTextEvent {
      color: #c84056;
      font-weight: bold;
    }

    .messageUsername {
      color: #000000;
      cursor: pointer;
      font-weight: bold;
      letter-spacing: -1px;
    }

    .enterRoomLink {
      position: absolute;
      margin-top: 2px;
      bottom: 2px;
      right: 2px;
      width: 31px;
      height: 16px;
      background: url('/nlivechat/img/ic_room_enter.png') no-repeat;
      cursor: pointer;
    }

    &.error,
    &.notify,
    &.system,
    &.warning,
    &.point,
    &.special_noti,
    &.shop {
      padding: 3px 5px;

      .messageText,
      .goShop,
      .needPoint {
        color: #ffffff;
        padding: 2px;
      }

      .goShop:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      .needPoint:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      .goShop,
      .needPoint {
        color: #fbff62
      }
    }

    &.error {
      border: 1px solid #0b290b;
      background-color: #1c701c;

      a {
        color: #ffff00;
      }
    }

    &.notify {
      border: 1px solid #18275c;
      background-color: #2943a3;
    }

    &.system {
      border: 1px solid #253c8f;
      background-color: #d73544;
    }

    &.warning {
      border: 1px solid #0b290b;
      background-color: #ff7400;
    }

    &.point {
      border: 1px solid #40153f;
      background-color: #882985;
    }

    &.special_noti {
      border: 1px soild #D96987;
      background-color: #c1627a;
    }

    &.lv4 {
      .messageUsername {
        color: #0988cb;
      }
    }

    &.lv5 {
      .messageUsername {
        color: #e02012;
      }
    }

    &.high_rank.medal,
    &.rank {
      .messageUsername {
        background: #990099;
        color: #fff;
        padding: 0 3px 0 0;
      }
    }

    &.rank20_100 {
      .messageUsername {
        background: #000;
        color: #fff;
      }
    }

    &.ic_crown1,
    &.ic_crown2,
    &.ic_crown3 {
      .messageUsername {
        padding-right: 1px;
        background-color: #990099;
        color: #fff;
      }
    }

    &.c_b {
      .messageUsername {
        color: #3498DB;
      }
    }

    &.c_r {
      .messageUsername {
        color: #e02012;
      }
    }

    &.c_m {
      .messageUsername {
        color: #FF69B4;
      }
    }

    &.c_g {
      .messageUsername {
        color: #35D866;
      }
    }

    &.c_p {
      .messageUsername {
        color: #8436D6;
      }
    }

    &.c_y {
      .messageUsername {
        color: #E5C53E;
      }
    }

    &.c_adm {
      .messageUsername {
        background: #e02012;
        color: #fff;
        padding: 0 3px 0 0;
      }
    }

    &.rank_medel,
    &.high_rank {
      line-height: 18px;

      img {
        float: left;
        vertical-align: middle;
        width: 18px;
        height: 18px;
      }

      .messageUsername {
        line-height: 18px;
        height: 18px;
        display: inline-block;
      }
    }

    &.high_rank {
      line-height: 24px;

      img {
        width: 24px;
        height: 24px;
        margin-right: 3px;
      }

      .messageUsername {
        line-height: 24px;
        height: 24px;
        display: inline-block;
      }
    }

    &.rank_medel {
      img {
        margin: 0 3px;
      }
    }

    &.ic_medal,
    &.ic_crown1,
    &.ic_crown2,
    &.ic_crown3 {
      &::before {
        content: "";
        position: relative;
        top: 8px;
        width: 19px;
        height: 19px;
        display: inline-block;
      }
    }

    &.ic_medal {
      &::before {
        background: url('/nlivechat/img/sp_ic_chatLog.png') no-repeat;
      }
    }

    &.ic_crown1 {
      &::before {
        background: url('/nlivechat/img/sp_ic_chatLog.png') no-repeat 0 -20px;
      }
    }

    &.ic_crown2 {
      &::before {
        background: url('/nlivechat/img/sp_ic_chatLog.png') no-repeat 0 -40px;
      }
    }

    &.ic_crown3 {
      &::before {
        background: url('/nlivechat/img/sp_ic_chatLog.png') no-repeat 0 -60px;
      }
    }

    &.mytalk {
      .messageText {
        color: #ef5b12;
      }
    }


    &.b_b {
      .messageText {
        color: #3498DB !important;
      }
    }

    &.mytalk.b_b {
      .messageText {
        color: #3498DB !important;
      }
    }

    &.b_r {
      .messageText {
        color: #e02012 !important;
      }
    }

    &.mytalk.b_r {
      .messageText {
        color: #e02012 !important;
      }
    }

    &.b_m {
      .messageText {
        color: #FF69B4 !important;
      }
    }

    &.mytalk.b_m {
      .messageText {
        color: #FF69B4 !important;
      }
    }

    &.b_g {
      .messageText {
        color: #35D866 !important;
      }
    }

    &.mytalk.b_g {
      .messageText {
        color: #35D866 !important;
      }
    }

    &.b_p {
      .messageText {
        color: #8436D6 !important;
      }
    }

    &.mytalk.b_p {
      .messageText {
        color: #8436D6 !important;
      }
    }

    &.b_y {
      .messageText {
        color: #E5C53E !important;
      }
    }

    &.mytalk.b_y {
      .messageText {
        color: #E5C53E !important;
      }
    }




    &.link {
      .messageText:after {
        content: " 링크";
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-message.vue?605cc69a